import { createContext, useContext } from "react";

export interface OrgChoice {
  segment: string;
  name: string;
  isHome: boolean;
}

export interface ActiveOrg extends OrgChoice {
  // Every org the session may act in, the home org first.
  choices: OrgChoice[];
}

export const OrgContext = createContext<ActiveOrg | undefined>(undefined);

export function useActiveOrg() {
  const value = useContext(OrgContext);
  if (value === undefined) {
    throw new Error("useActiveOrg must be used inside OrgScope");
  }
  return value;
}

export function orgLabel(name: string, unnamed: string) {
  return name || unnamed;
}
